export enum CHATS {
    /**
     * @value Chats
     * @description Name of the chats feature
     */
    PAGE_TITLE = 'GLOBAL.CHATS',
    /**
     * @value Smart Group Chats Management
     */
    SMART_GROUP_CHATS_MANAGEMENT_PAGE_TITLE = 'CHATS_FRONT_OFFICE.SMART_GROUP_CHATS_MANAGEMENT_PAGE_TITLE',
}
